import { toast } from "sonner";

let previousToastId;

// Sonner never forgets a toast id, so reusing a fixed id turns every later toast
// into an update of the first one. An update that lands while that toast is
// closing is dropped, so each copy dismisses the previous toast and opens a new
// one instead, which still keeps rapid copies from stacking.
const showCopyToast = notify => {
  if (previousToastId !== undefined) {
    toast.dismiss(previousToastId);
  }
  previousToastId = notify();
};

export async function copyTextToClipboard(
  text,
  { successMessage = "Copied to clipboard" } = {}
) {
  try {
    await navigator.clipboard.writeText(text);
    showCopyToast(() => toast.success(successMessage));
  } catch {
    // Covers both a denied permission and a browser without navigator.clipboard.
    showCopyToast(() => toast.error("Could not copy to clipboard"));
  }
}
